const { REACT_APP_REST_ENDPOINT } = process.env;
const COUPON_ENDPOINT = `${REACT_APP_REST_ENDPOINT}/coupon`;

const CouponService = {

    _handleJsonResponse: async (response) => {
        if (response.ok) {
            const text = await response.text();
            try {
                // Prova a fare il parsing come sempre
                return text ? JSON.parse(text) : { success: true };
            } catch (e) {
                // Se il parsing fallisce, ma lo stato è OK, consideralo un successo
                // ma mostra un avviso in console per il debug del backend.
                console.warn("La risposta del server non era JSON valido, ma lo stato era OK. Risposta:", text);
                return { success: true, debug_response: text };
            }
        } else {
            // Gestione degli errori migliorata
            const errorText = await response.text();
            try {
                // Prova a leggere l'errore come JSON
                const errorJson = JSON.parse(errorText);
                throw new Error(errorJson.message || "Si è verificato un errore");
            } catch (e) {
                // Se anche il corpo dell'errore non è JSON, mostra il testo grezzo
                throw new Error(errorText || `Errore del server: ${response.statusText}`);
            }
        }
    },

    getCampaigns(id_classi_superpartner) {
        const token = localStorage.getItem("token");
        return fetch(`${COUPON_ENDPOINT}/get`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify({ id_classi_superpartner })
        }).then(this._handleJsonResponse);
    },

    createCampaign(data) {
        const token = localStorage.getItem("token");
        return fetch(`${COUPON_ENDPOINT}/create`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify(data)
        }).then(this._handleJsonResponse);
    },

    deleteCampaign(id_promozione) {
        const token = localStorage.getItem("token");
        return fetch(`${COUPON_ENDPOINT}/delete`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify({ id_promozione })
        }).then(this._handleJsonResponse);
    },

    validateCoupon(codice_coupon, id_classi_superpartner) {
        const token = localStorage.getItem("token");
        return fetch(`${COUPON_ENDPOINT}/validate`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify({ codice_coupon, id_classi_superpartner })
        }).then(this._handleJsonResponse);
    },
    
    checkActiveCampaign(data) {
        const token = localStorage.getItem("token");
        return fetch(`${COUPON_ENDPOINT}/check-active`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify(data)
        }).then(this._handleJsonResponse);
    },

    recordCouponUsage(data) { 
        const token = localStorage.getItem("token");
        return fetch(`${COUPON_ENDPOINT}/record-usage`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data)
        }).then(this._handleJsonResponse);
    }
};

export default CouponService;

